"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = require("lodash");
const react_1 = require("react");
const simpleButton_1 = __importDefault(require("../../../../components/atoms/button/simpleButton"));
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const status_and_notifications_1 = require("../../../../hsbc_img/status_and_notifications");
const approvalQuery_1 = require("../../../../queries/approvals/approvalQuery");
const supportSettingsQuery_1 = require("../../../../queries/supportSettingsQuery");
const translationUtil_1 = require("../../../../utils/translationUtil");
const zustandStore_1 = require("../../../../zustandStore");
const lexico = new lexico_1.default();
const LinkAndApprovals = () => {
    const [companyId, setCompanyId] = (0, react_1.useState)('');
    const [goBranchId, setGoBranchId] = (0, react_1.useState)('');
    const [requestId, setRequestId] = (0, react_1.useState)('');
    const [readLinkClicked, setReadLinkClicked] = (0, react_1.useState)(false);
    const { setNotification } = (0, zustandStore_1.useZustand)();
    const storeGoBranchMutation = (0, supportSettingsQuery_1.useStoreGoBranchMutation)();
    const clearGoBranchMutation = (0, supportSettingsQuery_1.useClearGoBranchMutation)();
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    const useCloseStuckPendingApproval = (0, approvalQuery_1.useCloseStuckPendingApprovalMutation)();
    const { data: branchId, isSuccess, refetch: refetchGetGoBranch, } = (0, react_query_1.useQuery)((0, supportSettingsQuery_1.getGoBranchQuery)({ companyId, readLinkClicked }));
    const resetErrors = () => {
        setErrorMessage('');
    };
    const storeGoBranchId = () => {
        if (companyId === goBranchId) {
            setErrorMessage('Master Id and Go Branch Id should be different');
            setCompanyId('');
            setGoBranchId('');
            return;
        }
        storeGoBranchMutation.mutate({ companyId, goBranchId }, {
            onSuccess: () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: lexico.trc('Success message', 'Go branch has been linked.'),
                    },
                ]);
            },
            onError: () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: lexico.trc('Error message', 'There was problem in linking.'),
                    },
                ]);
            },
        });
    };
    const readGoBranchId = () => {
        setReadLinkClicked(true);
        void refetchGetGoBranch();
    };
    (0, react_1.useEffect)(() => {
        if (isSuccess) {
            setReadLinkClicked(false);
            if (branchId) {
                setGoBranchId(branchId);
            }
            else {
                setGoBranchId('');
            }
        }
    }, [branchId, isSuccess]);
    const clearGoBranchId = () => {
        clearGoBranchMutation.mutate({ companyId }, {
            onSuccess: () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: lexico.trc('Success message', 'Go branch has been de-linked.'),
                    },
                ]);
                setGoBranchId('');
            },
            onError: () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: lexico.trc('Error message', 'There was problem in de-linking.'),
                    },
                ]);
            },
        });
    };
    const forceCloseStuckApproval = () => {
        useCloseStuckPendingApproval.mutate(requestId, {
            onSuccess: () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: lexico.trc('Success message', 'Approval has been closed.'),
                    },
                ]);
            },
            onError: () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: lexico.trc('Error message', `There was a problem ${(0, translationUtil_1.getCancelledWord)('canceling')} the approval. No task has been found for subjectId ${requestId}`),
                    },
                ]);
                setRequestId('');
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { sx: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: 1,
        }, children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, { size: 12, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "overline", gutterBottom: true, sx: {
                            display: 'block',
                        }, children: strings_1.SupportSettingsStrings.LINK_GO_BRANCH }), (0, jsx_runtime_1.jsx)(material_1.TextField, { "data-testid": "masterBranchId-input", id: "masterBranchId", name: "masterBranchId", type: "text", value: companyId, placeholder: strings_1.SupportSettingsStrings.MASTER_BRANCH_ID_PLACEHOLDER, onChange: e => {
                            resetErrors();
                            setCompanyId(e.target.value);
                        }, variant: "outlined", sx: { padding: 0 } })] }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { size: 12, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { "data-testid": "goBranchId-input", id: "goBranchId", name: "goBranchId", type: "text", value: goBranchId, placeholder: strings_1.SupportSettingsStrings.GO_BRANCH_ID_PLACEHOLDER, onChange: e => {
                            resetErrors();
                            setGoBranchId(e.target.value);
                        }, variant: "outlined", sx: { padding: 0 } }), !(0, lodash_1.isEmpty)(errorMessage) && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", variant: 'outlined', icon: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusErrorOnLight, { style: { width: '24px', height: '24px' } })) : ((0, jsx_runtime_1.jsx)(Warning_1.default, {})), children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", sx: {
                                color: 'error',
                            }, children: errorMessage }) }))] }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { size: 12, children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { style: { marginRight: '20px' }, dataTestId: "read-link", onClick: () => readGoBranchId(), color: uiConstants_1.UI_BUTTON_PRIMARY, size: "small", disabled: !companyId, label: strings_1.SupportSettingsStrings.READ_LINK_BUTTON }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { style: { marginRight: '20px' }, dataTestId: "set-link", onClick: () => storeGoBranchId(), color: uiConstants_1.UI_BUTTON_PRIMARY, size: "small", disabled: !companyId || !goBranchId, label: strings_1.SupportSettingsStrings.SET_LINK_BUTTON }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "clear-link", onClick: () => clearGoBranchId(), color: uiConstants_1.UI_BUTTON_PRIMARY, size: "small", disabled: !companyId, label: strings_1.SupportSettingsStrings.CLEAR_LINK_BUTTON })] }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { size: 12, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "overline", gutterBottom: true, sx: {
                            display: 'block',
                        }, children: strings_1.SupportSettingsStrings.FORCE_CLOSE_STUCK_APPROVAL }), (0, jsx_runtime_1.jsx)(material_1.TextField, { "data-testid": "requestId-input", id: "requestId", name: "requestId", type: "text", value: requestId, placeholder: strings_1.SupportSettingsStrings.REQUEST_ID_PLACEHOLDER, onChange: e => {
                            resetErrors();
                            setRequestId(e.target.value);
                        }, variant: "outlined", sx: { padding: 0 } }), (0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { style: { display: 'flex' }, children: [(0, jsx_runtime_1.jsx)(Info_1.default, { color: "info", fontSize: "small", style: { verticalAlign: 'middle' } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", sx: { color: '#0f1519', fontSize: '12px', paddingLeft: '5px' }, children: strings_1.SupportSettingsStrings.USE_WITH_CAUTION_TEXT })] }), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: 4, children: (0, jsx_runtime_1.jsx)(simpleButton_1.default, { style: { margin: '10px 0 0 10px' }, dataTestId: "read-link", onClick: () => forceCloseStuckApproval(), color: uiConstants_1.UI_BUTTON_PRIMARY, size: "small", disabled: !requestId, label: strings_1.SupportSettingsStrings.CLOSE_APPROVAL_BUTTON }) })] })] }));
};
exports.default = LinkAndApprovals;
